import type { Task } from './types'

export type Query = {
  /** トレーダー名の完全一致。空なら条件にしない */
  trader: string
  /** タスク名と目標に対する部分一致。空白区切りの語をすべて含むこと */
  name: string
  /** マップの normalizedName の完全一致。空なら条件にしない */
  map: string
}

/**
 * AND検索。条件が1つも入っていなければ空を返す（全件は出さない）。
 *
 * 仕様には「LL」もあるが、tarkov.dev のデータにもロイヤリティレベルは無いため
 * 項目から外している（`minPlayerLevel` はプレイヤーレベルで、LL とは別物）。
 */
export function searchTasks(tasks: Task[], q: Query): Task[] {
  const name = q.name.trim().toLowerCase()
  const words = name ? name.split(/\s+/) : []
  if (!q.trader && !words.length && !q.map) return []

  return tasks.filter((t) => {
    if (q.trader && t.trader !== q.trader) return false
    if (q.map && !t.maps.includes(q.map)) return false
    if (words.length) {
      const hay = `${t.name} ${t.objectives.map((o) => o.description).join(' ')}`.toLowerCase()
      if (!words.every((w) => hay.includes(w))) return false
    }
    return true
  })
}
